import type {FC} from 'react';

import {omit} from 'es-toolkit';
import styled from 'styled-components';

import type {WithDomStyleProp} from '../../utils/utility-types';
import type {Props, StyledProps} from './types';

import {Clickable} from '../Clickable';
import {View} from '../View';
import {useController} from './controller';
import {containerWeb, thumbWeb} from './styles';

const StyledContainer = styled(View)<StyledProps>`
  ${containerWeb}
`;

const StyledThumb = styled(View)<StyledProps>`
  ${thumbWeb}
`;

const Toggle: FC<WithDomStyleProp<Props>> = props => {
  const {onClick} = useController(props);

  const {isDisabled, style, testID, ...rest} = omit(props, ['onClick']);

  return (
    <Clickable disabled={isDisabled} onClick={onClick} testID={testID}>
      <StyledContainer {...rest} isDisabled={isDisabled} style={style}>
        <StyledThumb {...rest} />
      </StyledContainer>
    </Clickable>
  );
};

export {Toggle};
